"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTravelDestination = void 0;
var React = __importStar(require("react"));
var IconTravelDestination = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M20,11.1201 C19.107,11.5061 16.275,12.5631 14.831,11.1101 C14.049,10.3241 12.905,10.0671 11.744,10.0671 C10.302,10.0671 8.833,10.4631 8,10.7331 L8,3.7241 C8.906,3.3421 11.824,2.2921 13.688,3.7931 C15.762,5.4601 18.673,4.7931 20,4.3541 L20,11.1201 Z M11,19.9891 C11,20.2811 9.773,20.9941 7.5,20.9941 C5.227,20.9941 4,20.2811 4,19.9891 C4,19.7211 5.055,19.0991 7,19.0031 L7,19.4861 C7,19.7651 7.224,19.9891 7.5,19.9891 C7.776,19.9891 8,19.7651 8,19.4861 L8,19.0031 C9.945,19.0991 11,19.7211 11,19.9891 L11,19.9891 Z M20.773,3.2101 C20.631,3.1161 20.452,3.1011 20.298,3.1711 C20.26,3.1871 16.55,4.8081 14.313,3.0071 C11.594,0.8201 7.452,2.8621 7.276,2.9501 C7.107,3.0361 7,3.2101 7,3.4001 L7,11.4371 L7,11.4491 L7,18.0261 C4.929,18.1181 3,18.7661 3,19.9891 C3,21.3091 5.264,22.0001 7.5,22.0001 C9.736,22.0001 12,21.3091 12,19.9891 C12,18.7661 10.071,18.1181 8,18.0261 L8,11.7921 C9.504,11.2581 12.78,10.4721 14.124,11.8211 C16.354,14.0631 20.547,11.9811 20.725,11.8911 C20.894,11.8071 21,11.6341 21,11.4431 L21,3.6311 C21,3.4611 20.915,3.3021 20.773,3.2101 L20.773,3.2101 Z" }))); };
exports.IconTravelDestination = IconTravelDestination;
exports.IconTravelDestination.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconTravelDestination;
